import { IDropdownOption } from '@fluentui/react';
import FilterButton from '../../../common/views/FilterButton';
import { MenuFilterModel } from '../../models/CategoryModel';
import { UserProductFilterModel } from '../../models/ProductModel';

export type ProductFilterTextProps = {
    filter: UserProductFilterModel;
    sizeOptions: IDropdownOption[];
    onChange: (newFilter: UserProductFilterModel) => void;
}

export default function ProductFilterTextView({ filter, sizeOptions, onChange }: ProductFilterTextProps) {
    const onDeleteCategoryFilterText = (currentItem: MenuFilterModel) => {
        filter.menuFilters = filter.menuFilters.filter(
            item => !(item.type === currentItem.type && item.value === currentItem.value)
        );

        onChange(filter);
    }

    return <>
        {filter.menuFilters.map((item: MenuFilterModel, index: number) => {
            return <>
                <FilterButton
                    text={item.text}
                    onDelete={() => onDeleteCategoryFilterText(item)}
                />
            </>;
        })}
    </>;
}